import { render, staticRenderFns } from "./AddReward.vue?vue&type=template&id=dee0761a&"
import script from "./AddReward.vue?vue&type=script&lang=js&"
export * from "./AddReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports